import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ConverterService,
  Occ,
  OccEndpointsService,
  OccRequestsOptimizerService,
  Product,
  PRODUCT_NORMALIZER,
  ProductAdapter,
  ScopedDataWithUrl,
  ScopedProductData,
} from '@spartacus/core';
import { Observable } from 'rxjs';
import { KnBrCustomerContextService } from 'src/app/store/kn-br-customer-context/kn-br-customer-context.service';
import { KN_BR_CUSTOMER_CURRENT } from 'src/constants/api.endpoints.constant';

@Injectable()
export class KnBrOccProductAdapter implements ProductAdapter {
  customerId: string;
  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converter: ConverterService,
    protected requestsOptimizer: OccRequestsOptimizerService,
    private customerContextService: KnBrCustomerContextService
  ) {
    this.customerContextService.get$.subscribe((response) => {
      this.customerId = response && response.customerNumber ? response.customerNumber : null;
    });
  }

  load(productCode: string, scope?: string): Observable<Product> {
    return this.http.get(this.getEndpoint(productCode, scope)).pipe(this.converter.pipeable(PRODUCT_NORMALIZER));
  }

  loadMany(products: ScopedProductData[]): ScopedProductData[] {
    const scopedDataWithUrls: ScopedDataWithUrl[] = products.map((model) => ({
      scopedData: model,

      url: this.getEndpoint(model.code, model.scope),
    }));

    return this.requestsOptimizer.scopedDataLoad<Occ.Product>(scopedDataWithUrls).map(
      (scopedProduct) =>
        ({
          ...scopedProduct,
          data$: scopedProduct.data$.pipe(this.converter.pipeable(PRODUCT_NORMALIZER)),
        } as ScopedProductData)
    );
  }

  protected getEndpoint(code: string, scope?: string): string {
    const CUSTOMER_NUMBER = this.customerId ? this.customerId : KN_BR_CUSTOMER_CURRENT;

    return this.occEndpoints.buildUrl('product', {
      urlParams: {
        productCode: code,
        customerId: CUSTOMER_NUMBER,
      },
      scope,
    });
  }
}
